__webpack_require__.p = "/acquisition-contracts-routes/onboarding/";